import {
  IonIcon,
  IonItem,
  IonModal,
  IonButton,
  IonText,
} from "@ionic/react";
import { codeOutline } from "ionicons/icons";
import React, { useState } from "react";
import "./WEAppDev.css";

function WEAppDev() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <IonItem className="ion-hide-sm-up ion-align-items-center">
        <IonIcon icon={codeOutline} slot="start" className="ion-icon"></IonIcon>
        <IonModal
          isOpen={showModal}
          className="ion-modal-popup"
          backdropDismiss="false"
        >
          <IonText className="ion-justify-content-center ion-align-items-center ion-margin">
            <br />
            <b>App Dev TA @ Chicago Booth</b>
            <br />
            <p>
              From January 2021 to December 2021, I taught Ruby on Rails
              part-time as a course assistant in a full-stack application
              development class at the Chicago Booth School of Business. I held
              weekly office hours and assisted both undergraduate students and
              MBA students.{" "}
            </p>
            <br />
          </IonText>

          <IonButton
            className="ion-button"
            expand="block"
            onClick={() => setShowModal(false)}
          >
            Close
          </IonButton>
        </IonModal>

        <IonButton
          className="ion-button"
          expand="block"
          onClick={() => setShowModal(true)}
        >
          Show
        </IonButton>
      </IonItem>
    </div>
  );
}

export default WEAppDev;
